module.exports = __webpack_public_path__ + "img/ca60910a3d93a5166f83b4541c911300.png";